window.config = require('@config/config.js');
const CONFIG = new config();

const store = {
    namespaced: true,
    state: {
        admin_converters_routes: {
            "index": CONFIG.neuron_url + "/admin/converters",
            "show": CONFIG.neuron_url + "/admin/converters/:id",
            "create": CONFIG.neuron_url + "/admin/converters/create",
            "update": CONFIG.neuron_url + "/admin/converters/:id/update",
            "destroy": CONFIG.neuron_url + "/admin/converters/:id/destroy",
        },
    },
    getters: {
    },
    mutations: {
    }
}

export default store
